import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type LoadReportOut = components["schemas"]["LoadReportOut"];
export type LoadReportListOut = components["schemas"]["LoadReportListOut"];

/** Loads that created records and have not been taken back, newest first.
 *
 *  Feeds the Undo node's picker, so it lists only what could actually be
 *  undone — an empty choice in a destructive picker is worse than no choice. */
export function listLoadReports(token: string, pipelineId?: string): Promise<LoadReportListOut> {
  const query = pipelineId ? `?pipeline_id=${encodeURIComponent(pipelineId)}` : "";
  return apiFetch<LoadReportListOut>(`/api/v1/load-reports${query}`, { token });
}

/** What one run put into its targets — the "what did this actually change?"
 *  answer, from the run you are looking at. */
export function listRunLoadReports(
  token: string,
  pipelineId: string,
  runId: string,
): Promise<LoadReportListOut> {
  return apiFetch<LoadReportListOut>(
    `/api/v1/pipelines/${encodeURIComponent(pipelineId)}/runs/${encodeURIComponent(runId)}/load-reports`,
    { token },
  );
}
